import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import BaseArticles from "./BaseArticles/BaseArticles";
import PackageMappings from "./BaseArticles/PackageMappings";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const BaseArticlesTab = ({
  onNavigateToPlatform,
  initialSku = null,
  onNavConsumed,
}) => {
  const [baseArticlesTab, setbaseArticlesTab] = useState(0);

  React.useEffect(() => {
    if (initialSku) {
      setbaseArticlesTab(0);
    }
  }, [initialSku]);

  const handlebaseArticlesTabChange = (event, newValue) => {
    setbaseArticlesTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={baseArticlesTab}
              onChange={handlebaseArticlesTabChange}
              aria-label="base articles tabs"
            >
              <Tab label="Articles" />
              <Tab label="Package Mappings" />
            </Tabs>
          </Box>

          {/* Base Articles Tab */}
          <TabPanel value={baseArticlesTab} index={0}>
            <BaseArticles
              initialSku={initialSku}
              onNavConsumed={onNavConsumed}
              onNavigateToPlatform={onNavigateToPlatform}
            />
          </TabPanel>
          {/* Package Mappings Tab */}
          <TabPanel value={baseArticlesTab} index={1}>
            <PackageMappings />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BaseArticlesTab;
